import { Injectable } from '@angular/core';
import { SecurityDomain } from 'lib';
import { environment } from '../../environments/environment';
import { DomainConfig } from '../interfaces/domain-config';

@Injectable({
    providedIn: 'root'
})
export class DomainDetectorService {
    private domainConfig: DomainConfig | null = null;

    async detectDomain(): Promise<DomainConfig> {
        if (this.domainConfig) {
            return this.domainConfig;
        }

        // For local development, allow override via localStorage
        if (!environment.production) {
            const localOverride = localStorage.getItem('mm-sso-domain');
            if (localOverride) {
                // Using console.error for dev logging as console.log is restricted by linter
                console.error(`[DEV OVERRIDE] Using localStorage mm-sso-domain: ${localOverride}`);
                const isEyefinity = localOverride.toLowerCase() === 'eyefinity';
                this.domainConfig = {
                    securityDomain: isEyefinity ? SecurityDomain.EYEFINITY : SecurityDomain.MODMED,
                    keycloakRealm: isEyefinity ? 'mm-sso-ef-admin' : 'mm-sso-admin'
                };
                return this.domainConfig;
            }
        }

        try {
            const response = await fetch(window.location.href, { method: 'HEAD' });
            const headerValue = response.headers.get('Mm-Sso-Domain')?.toLowerCase();

            const isEyefinity = headerValue === 'eyefinity';
            this.domainConfig = {
                securityDomain: isEyefinity ? SecurityDomain.EYEFINITY : SecurityDomain.MODMED,
                keycloakRealm: isEyefinity ? 'mm-sso-ef-admin' : 'mm-sso-admin'
            };
        } catch (error) {
            console.error('Failed to detect domain from header, defaulting to MODMED', error);
            this.domainConfig = {
                securityDomain: SecurityDomain.MODMED,
                keycloakRealm: 'mm-sso-admin'
            };
        }

        return this.domainConfig;
    }

    getDomainConfig(): DomainConfig {
        if (!this.domainConfig) {
            return {
                securityDomain: SecurityDomain.MODMED,
                keycloakRealm: 'mm-sso-admin'
            };
        }
        return this.domainConfig;
    }
}
